import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ReservationSummaryCommissionEditDialogApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	updateCommissionValue(reservationId: number, newCommissionValue: number): Observable<void> {
		return this.httpClient.patch<void>(`${this.apiUrl}/reservation/${reservationId}/`, {
			commissionValue: newCommissionValue,
		});
	}
}
